import FutureImage from '../FutureImage';
import imageCrop from 'helpers/imageCrop';

// A print from the field: destination photo in a slim white mat with its
// caption typed on the bottom edge. `fullBleed` drops the mat and runs the
// photo edge to edge — air between dense guide chapters.
export default function DestinationImage({ image, isPrio, rotate, fullBleed }) {
  if (!image || !image.url) return null;
  if (fullBleed)
    return (
      <figure className="tw-relative tw-m-0 tw-h-[40vh] tw-min-h-[17rem] tw-max-h-[33rem] tw-overflow-hidden">
        <FutureImage
          src={imageCrop(image.url, 2000)}
          alt={image.alt || ''}
          fill
          unoptimized
          sizes="100vw"
          className="tw-object-cover"
          blurDataURL={image.blur}
          placeholder={image.blur ? 'blur' : undefined}
          priority={isPrio}
        />
        {image.alt && (
          <figcaption className="tw-absolute tw-bottom-4 tw-right-6 tw-m-0 tw-rounded-full tw-bg-[rgba(12,20,17,0.45)] tw-px-3.5 tw-py-1.5 tw-font-mono tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-[0.22em] tw-text-[#F5F1E6] tw-backdrop-blur-sm [&::after]:tw-hidden">
            {image.alt}
          </figcaption>
        )}
      </figure>
    );
  return (
    <figure
      className={`tw-m-0 tw-rounded-lg tw-bg-white dark:tw-bg-[#EFEAE0] tw-p-1.5 tw-pb-0 sm:tw-p-2 sm:tw-pb-0 tw-shadow-[0_24px_50px_-28px_rgba(29,45,40,0.45)] ${
        rotate || ''
      }`}
    >
      <div className="tw-relative tw-aspect-[16/9] tw-overflow-hidden tw-rounded-md">
        <FutureImage
          src={imageCrop(image.url, 1200)}
          alt={image.alt || ''}
          fill
          unoptimized
          sizes="(max-width: 1320px) 96vw, 1280px"
          className="tw-object-cover"
          blurDataURL={image.blur}
          placeholder={image.blur ? 'blur' : undefined}
          priority={isPrio}
        />
      </div>
      {image.alt && (
        <figcaption className="tw-px-1 tw-py-2 tw-text-center tw-font-mono tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-[0.22em] tw-text-[#5F6F69] [&::after]:tw-hidden">
          {image.alt}
        </figcaption>
      )}
    </figure>
  );
}
